import { apiSlice } from "./apiSlice";

export const vendorsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVendors: builder.query({
      query: ({search}) => {
        return `/vendors?search=${search}`
      },
      providesTags: (result = [], error, arg) => [{ type: 'Vendors', id: JSON.stringify(arg) }],
    }),
    getVendor: builder.query({
      query: (id) => {
        return `/vendors/${id}`
      },
      providesTags: (result = [], error, arg) => [{ type: 'Vendors', id: arg }],
    })
  }),
  overrideExisting: false
})

export const {
  useLazyGetVendorsQuery,
  useLazyGetVendorQuery,
} = vendorsApiSlice
